import React, { useState, useEffect } from 'react';
import { useSocket } from '../context/SocketContext';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../i18n';
import { useNavigate } from 'react-router-dom';
import UserCard from '../components/UserCard';
import ChatBox from '../components/ChatBox';
import axios from 'axios';
const _api = axios.create({baseURL:'/api'});
_api.interceptors.request.use(function(r){var t=localStorage.getItem('token');if(t)r.headers.Authorization='Bearer '+t;return r;});

export default function DiscoveryPage() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [profileCompletion, setProfileCompletion] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  var [reqMsg,setReqMsg]=React.useState('');
  function sendReq(id){_api.post('/friends/request',{toUserId:id}).then(function(){setReqMsg(t('friendsAdd')+' ✓');setTimeout(function(){setReqMsg('')},2000);}).catch(function(e){setReqMsg(e.response?.data?.error||'Failed');setTimeout(function(){setReqMsg('')},3000);});}
  const [users, setUsers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [activeRegion, setActiveRegion] = useState('ALL');
  const [activeChat, setActiveChat] = useState(null);
  const [activePartner, setActivePartner] = useState(null);
  const [session, setSession] = useState({ id: null });
  const { user } = useAuth();
  const { socket, safeEmit } = useSocket();

  const REGIONS = [
    { code: 'ALL', label: '🌐 ' + t('discoverAll') },
    { code: 'JP', label: '🇯🇵 日本' },
    { code: 'KR', label: '🇰🇷 韩国' },
    { code: 'CN', label: '🇨🇳 中国' },
    { code: 'US', label: '🇺🇸 美国' },
    { code: 'ES', label: '🇪🇸 西班牙' },
    { code: 'FR', label: '🇫🇷 法国' },
    { code: 'IT', label: '🇮🇹 意大利' },
    { code: 'RU', label: '🇷🇺 俄罗斯' },
  ];

  // Incoming message notification
  const [incomingMsg, setIncomingMsg] = useState(null);
  useEffect(() => {
    if (!socket) return;
    var handler = function(msgData) {
      var msg = msgData.message;
      if (msg.sender_id === session?.user_id_1 || msg.sender_id === session?.user_id_2) return;
      var sender = users.find(function(u) { return u.user_id === msg.sender_id; });
      if (sender) setIncomingMsg({ user:sender, text:msg.original_text });
      setTimeout(function(){ setIncomingMsg(null); }, 6000);
    };
    socket.on('new_message', handler);
    return function() { socket.off('new_message', handler); };
  }, [socket, users, session]);

  var handleIncoming = function(incoming) {
    setIncomingMsg(null);
    setActivePartner(incoming.user);
    setActiveChat(true);
    if (socket) {
      socket.emit('create_session', { targetUserId: incoming.user.user_id });
      var onS = function(s) { setSession(s); socket.off("session_created", onS); };
      socket.on('session_created', onS);
    }
  };

  useEffect(() => {
    if (!user?.id) return;
    _api.get('/profile/' + user.id).then(res => {
      const p = res.data || {};
      const done = [p.display_name, p.bio, p.avatar_url, p.intent, p.prompt1, p.prompt2].filter(Boolean).length;
      setProfileCompletion(Math.round(done / 6 * 100));
    }).catch(() => {});
  }, [user?.id]);

  // 从后端获取种子用户
  useEffect(() => {
    axios.get('/api/seed-users').then((res) => {
      setUsers(res.data);
    }).catch(() => {});
  }, []);

  // 按地区+搜索过滤
  useEffect(() => {
    const kw = searchTerm.toLowerCase().trim();
    const code = activeRegion === 'ALL' ? '' : activeRegion;
    let list = code ? users.filter(u => u.country_code === code) : users;
    list = list.filter(u => u.user_id !== user?.id);
    if (kw) {
      list = list.filter(u =>
        (u.display_name || '').toLowerCase().includes(kw) ||
        (u.username || '').toLowerCase().includes(kw)
      );
    }
    setFiltered(list);
  }, [activeRegion, users, user, searchTerm]);

  const handleChat = (targetUser) => {
    setActivePartner(targetUser);
    setActiveChat(true);
    if (socket) {
      socket.emit('create_session', { targetUserId: targetUser.user_id });
      const handler = (s) => { setSession(s); socket.off('session_created', handler); };
      socket.on('session_created', handler);
    }
  };

  return (
    <div className="page-content">
      <div className="discovery-header">
        <h2>🌍 {t('discoverTitle')}</h2>
        <p className="subtitle">{t('discoverSubtitle')}</p>
      </div>

      {profileCompletion !== null && profileCompletion < 80 && <div className="card form-card" style={{maxWidth:600,margin:'0 auto 18px',display:'flex',alignItems:'center',justifyContent:'space-between',gap:14}}><div><strong>让别人更快了解你</strong><div style={{fontSize:'.82rem',color:'var(--text-dim)',marginTop:4}}>资料完成度 {profileCompletion}% · 补充头像、简介和回答，更容易遇到合适的人。</div></div><button className="btn btn-primary" onClick={() => navigate('/profile/'+user.id+'?onboarding=1')} style={{whiteSpace:'nowrap'}}>完善资料</button></div>}

      <div className="discovery-stats">
        <div className="stat-item">
          <div className="stat-number">10+</div>
          <div className="stat-label">{t('language')}</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">{users.length}</div>
          <div className="stat-label">{t('online')}</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">8</div>
          <div className="stat-label">{t('country')}</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">⚡</div>
          <div className="stat-label">{t('chatTranslate')}</div>
        </div>
      </div>

      <div style={{marginBottom:12,maxWidth:400,marginLeft:'auto',marginRight:'auto'}}>
        <input
          type="text"
          placeholder={t('search') + '...'}
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{
            width:'100%',padding:'10px 14px',borderRadius:8,border:'1px solid rgba(255,255,255,0.1)',
            background:'rgba(255,255,255,0.05)',color:'white',fontSize:'0.9rem',boxSizing:'border-box',
            outline:'none',transition:'border 0.2s'
          }}
          onFocus={e => e.target.style.borderColor = '#4f7cff'}
          onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
        />
      </div>
      <div className="discovery-filters">
        {REGIONS.map((r) => (
          <button key={r.code} className={`filter-btn ${activeRegion === r.code ? 'active' : ''}`}
            onClick={() => setActiveRegion(r.code)}>{r.label}</button>
        ))}
      </div>

      <div className="users-grid">
        {filtered.map((u) => (
          <UserCard key={u.user_id} user={u} onChat={handleChat} onAddFriend={sendReq} />
        ))}
        {filtered.length === 0 && (
          <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: 40, color: 'var(--text-dim)' }}>
            {t('discoverEmpty')}
          </div>
        )}
      </div>

      {activeChat && activePartner && (
        <ChatBox
          session={session}
          partner={activePartner}
          onClose={() => { setActiveChat(false); setActivePartner(null); setSession({ id: null }); }}
        />
      )}
          {reqMsg && <div style={{position:"fixed",top:76,left:"50%",transform:"translateX(-50%)",padding:"8px 20px",borderRadius:10,background:"#4ade80",color:"#fff",fontWeight:600,zIndex:9999,fontSize:"0.85rem"}}>{reqMsg}</div>}
      {incomingMsg && (
        <div style={{
          position:"fixed", top:76, left:"50%", transform:"translateX(-50%)",
          zIndex:9999, background:"var(--accent)", color:"#fff",
          padding:"10px 20px", borderRadius:12, cursor:"pointer",
          boxShadow:"0 4px 20px rgba(0,0,0,.25)", maxWidth:360, width:"90%",
          display:"flex", alignItems:"center", gap:10
        }} onClick={function(){handleIncoming(incomingMsg)}}>
          <div style={{width:36,height:36,borderRadius:"50%",background:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:"1rem"}}>
            {incomingMsg.user?.display_name?.charAt(0)?.toUpperCase() || "?"}
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:"0.85rem",fontWeight:600}}>{incomingMsg.user?.display_name || incomingMsg.user?.username}</div>
            <div style={{fontSize:"0.78rem",opacity:.85,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{incomingMsg.text}</div>
          </div>
          <span style={{fontSize:"1.2rem",opacity:.7}}>→</span>
        </div>
      )}
    </div>
  );
}
